import { defineComponent, ref, computed } from "vue";
import DeviceModule from "@/store/modules/device";
export default defineComponent({
  name: "DeviceSettings",
  components: {},
  setup: function setup() {
    var deviceId = ref(DeviceModule.deviceId || null);
    var devices = computed(function () {
      var deviceInfo = DeviceModule.deviceInfo,
          devicesFetched = DeviceModule.devices;

      if (!devicesFetched.length && deviceInfo) {
        return [deviceInfo];
      }

      return devicesFetched;
    });
    DeviceModule.fetchDevices();
    return {
      deviceId: deviceId,
      devices: devices
    };
  }
});